<script lang="ts">
  export let style = "";
  export let size = "medium";
  export let color: string | undefined = undefined;
  export let align = "left";
  export let nowrap = false;
  export let inline = false;
  export let bold = false;
  export let ocd = false;

  if (color) {
    style += `; color: var(--rekki-${color})`;
  }

  if (align) {
    style += `; text-align: ${align}`;
  }

  if (ocd) {
    style += `; font-family: REKKI-OCD; text-transform: uppercase`;
  }
</script>

<span class:bold class:nowrap class:inline class:ocd class="text-{size}" {style}><slot /></span>

<style>
  /* dunno what this is trying to do but i think it's been invalid for as long as i've seen it
    :root {
      --align-left: text-align: left;
      } */

  span {
    display: block;
    word-wrap: break-word;
  }

  .inline {
    display: inline-block;
  }

  .nowrap {
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .bold {
    font-family: "REKKI-Medium";
  }
</style>
